/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-28T09:36:42+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-28T10:01:03+02:00
*/


import React, {Component} from 'react';

/**
 * MPositionFormChildrenCheckout - …
**/
class MPositionFormChildrenCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
		 return (
		        <span {...this.props} className="m-position-form-children m-position-form-children-checkout" />
		    );
  }
}


MPositionFormChildrenCheckout.propTypes = {};
MPositionFormChildrenCheckout.defaultProps = {};
export default MPositionFormChildrenCheckout;
